import paths from 'shared/constants/paths';
import { resolve } from './pathResolver';

export const image = (name: string, data = {}) =>
  resolve(paths.images, name, data);
export const route = (name: string, data = {}) =>
  resolve(paths.routes, name, data);
